export function getTenantFromSubdomain(): string | null {
  const host = window.location.hostname
  const parts = host.split('.')
  if (parts.length < 3) return null
  const sub = parts[0].toLowerCase()
  const RESERVED = ['app', 'www', 'api', 'admin', 'mail', 'smtp']
  if (RESERVED.includes(sub)) return null
  return sub.toUpperCase()
}

export function getTenantUrl(code: string): string {
  const host = window.location.hostname
  const parts = host.split('.')
  if (parts.length >= 2) {
    const baseDomain = parts.slice(-2).join('.')
    return `${window.location.protocol}//${code.toLowerCase()}.${baseDomain}`
  }
  return window.location.origin
}
